/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import {
  CARD_TITLES,
  VALID_MODAL_TITLES,
  incomingBagsColumns,
  outscanBagsColumns,
  outscanToCPShipmentsColumns,
  inscanBagsColumns,
  inscanShipmentsColumns,
  outscanShipmentsColumns,
  incomingShipmentsColumns,
  cardStyles
} from "./constants";
import {
  Row,
  Col,
  Card,
  List,
  Form,
  Spin,
  message,
  Tooltip,
  Tabs,
  Modal,
  Table,
} from "antd";

import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined, } from "@ant-design/icons";

import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useCopilotReadable } from "@copilotkit/react-core";

import "./index.scss";
import dashbordMessageIcon from "../../assests/images/dashbord-message-icon.svg";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";
import attachmentIcon from "../../assests/images/paperpin.svg";
import shipmentHeaderIcon from "../../assests/images/shipment-dashboard.svg";
import bagHeaderIcon from "../../assests/images/bag-dashboard.svg";
import dashboardTopIcon from "../../assests/images/dashboard-square-setting.svg";
import quickActionTopIcon from "../../assests/images/setup-01.svg";
import liveTicketTopIcon from "../../assests/images/ticket-01.svg";

import { dashboardMenuList } from "../../config/dashboard";
import DashbordCard from "./DashbordCard";
import roleConstants from "../../constants/constants";
const { ROLES } = roleConstants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM
} = ROLES;
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import {
  getDashboardIncomingBagsClickable,
  getDashboardOutscanBagsClickable,
  getDashboardOutscanToCpShipmentsClickable,
  getDashboardInscanShipmentsClickable,
  getDashboardOutscanShipmentsClickable,
  getDashboardIncomingShipmentsClickable,
  getDashboardInscanBagsClickable,
  getRegexPatternAction,
  getAnnouncementsAction
} from "../../actionsMethods/dashboardMethods";
import {getToken, getPremiseId } from "../../utils/worker";
import axios from "axios";
import moment from "moment";
import urls from "../../api/urls";
import { showErrorMessage } from "../../utils";
import { LiveTickets, TicketDetail } from "hubops-live-ticket-component";
import "hubops-live-ticket-component/dist/style.css";

const premiseId = getPremiseId();
function Dashboard() {
  const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
  const primaryRole = userinfo?.roles?.[0];
  const getRole = primaryRole?.replace(/.*_/, "");
  const showDashboardSection =
    primaryRole === HUB_ADMIN ||
    primaryRole === ROLE_HUBOPERATOR ||
    primaryRole === HO_ADMIN ||
    primaryRole === DEVELOPER ||
    userinfo?.roles?.includes(HUB_ADMIN) ||
    userinfo?.roles?.includes(ROLE_HUBOPERATOR) ||
    userinfo?.roles?.includes(HO_ADMIN) ||
    userinfo?.roles?.includes(DEVELOPER);

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);

  const [accountDetails, setAccountDetails] = useState();
  const [day, setDay] = useState(1);
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState([]);
  const [modalTab, setModalTab] = useState(undefined);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isAnnouncementModalVisible, setIsAnnouncementModalVisible] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [cardDetailsModal, setCardDetailsModal] = useState({ visible: false, title: "", count: 0, type: "" });
  const [incomingBagsData, setIncomingBagsData] = useState([]);
  const [incomingBagsPagination, setIncomingBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isIncomingBagsLoading, setIsIncomingBagsLoading] = useState(false);
  const [outscanBagsData, setOutscanBagsData] = useState([]);
  const [outscanBagsPagination, setOutscanBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanBagsLoading, setIsOutscanBagsLoading] = useState(false);
  const [outscanToCPShipmentsData, setOutscanToCPShipmentsData] = useState([]);
  const [outscanToCPShipmentsPagination, setOutscanToCPShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanToCPShipmentsLoading, setIsOutscanToCPShipmentsLoading] = useState(false);
  const [inscanShipmentsData, setInscanShipmentsData] = useState([]);
  const [inscanShipmentsPagination, setInscanShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isInscanShipmentsLoading, setIsInscanShipmentsLoading] = useState(false);
  const [outscanShipmentsData, setOutscanShipmentsData] = useState([]);
  const [outscanShipmentsPagination, setOutscanShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanShipmentsLoading, setIsOutscanShipmentsLoading] = useState(false);
  const [incomingShipmentsData, setIncomingShipmentsData] = useState([]);
  const [incomingShipmentsPagination, setIncomingShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isIncomingShipmentsLoading, setIsIncomingShipmentsLoading] = useState(false);
  const [inscanBagsData, setInscanBagsData] = useState([]);
  const [inscanBagsPagination, setInscanBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isInscanBagsLoading, setIsInscanBagsLoading] = useState(false);
  const [rightPanelView, setRightPanelView] = useState("live");
  const statsContentRef = useRef(null);
  const liveTicketPanelRef = useRef(null);
  const quickActionPanelRef = useRef(null);

  useLayoutEffect(() => {
    const syncPanelHeights = () => {
      const livePanelEl = liveTicketPanelRef.current;
      const quickPanelEl = quickActionPanelRef.current;

      if (showDashboardSection) {
        if (quickPanelEl) quickPanelEl.style.height = "";
        const statsEl = statsContentRef.current;
        if (!statsEl || !livePanelEl) return;
        livePanelEl.style.height = `${statsEl.offsetHeight}px`;
        return;
      }

      if (livePanelEl) livePanelEl.style.height = "";
      if (!livePanelEl || !quickPanelEl) return;
      quickPanelEl.style.height = `${livePanelEl.offsetHeight}px`;
    };

    const runSync = () => {
      requestAnimationFrame(syncPanelHeights);
    };

    runSync();

    const resizeObserver = new ResizeObserver(runSync);
    const observeEl = showDashboardSection
      ? statsContentRef.current
      : liveTicketPanelRef.current;
    if (observeEl) {
      resizeObserver.observe(observeEl);
    }

    window.addEventListener("resize", runSync);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", runSync);
      if (liveTicketPanelRef.current) {
        liveTicketPanelRef.current.style.height = "";
      }
      if (quickActionPanelRef.current) {
        quickActionPanelRef.current.style.height = "";
      }
    };
  }, [
    showDashboardSection,
    todayData,
    loading,
    rightPanelView,
    accountDetails,
  ]);

  // Make dashboard data available to CopilotKit
  useCopilotReadable({
    description: "Current dashboard data including shipment counts, user information, and operational metrics",
    value: {
      currentUser: {
        username: accountDetails?.username,
        role: getRole,
        roles: userinfo?.roles || [],
        premiseId: premiseId?.split("Bearer ")[1]
      },
      dashboardMetrics: {
        selectedDay: day,
        todayData: todayData,
        loading: loading
      },
      availableMenuItems: dashboardMenuList.filter(item =>
        item.role.some(role => userinfo?.roles?.includes(role))
      ).map(item => ({
        title: item.title,
        id: item.id,
        route: item.route
      })),
      announcements: dataSource?.length > 0 ? dataSource.map(announcement => ({
        title: announcement.title,
        content: announcement.message,
        date: announcement.createdDate
      })) : [],
      shipmentStatus: todayData ? {
        inbound: todayData.inbound || {},
        outbound: todayData.outbound || {},
        hubOperations: todayData.hubOperations || {}
      } : null,
      currentTime: day,
      lastUpdated: new Date().toISOString()
    }
  });

  // Make dashboard menu configuration available
  useCopilotReadable({
    description: "Dashboard menu configuration and available features based on user role",
    value: {
      userRole: getRole,
      availableFeatures: dashboardMenuList
        .filter(item => item.role.some(role => userinfo?.roles?.includes(role)))
        .map(item => ({
          name: item.title,
          id: item.id,
          route: item.route,
          description: `Navigate to ${item.title} section`
        })),
      roleBasedAccess: {
        canAccessBooking: userinfo?.roles?.includes(CP_ADMIN),
        canAccessHubOperations: userinfo?.roles?.includes(HUB_ADMIN) || userinfo?.roles?.includes(ROLE_HUBOPERATOR) || userinfo?.roles?.includes(HO_ADMIN),
        canAccessReports: userinfo?.roles?.some(role =>
          [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM].includes(role)
        ),
        canAccessMasterSettings: userinfo?.roles?.some(role =>
          [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM].includes(role)
        )
      }
    }
  });

  // Make operational data available
  useCopilotReadable({
    description: "Real-time operational data and shipment tracking information",
    value: {
      operationalData: todayData ? {
        inboundShipments: {
          incoming: todayData.inbound?.incoming || 0,
          inscan: todayData.inbound?.inscan || 0,
          pending: todayData.inbound?.pending || 0,
          total: (todayData.inbound?.incoming || 0) + (todayData.inbound?.inscan || 0) + (todayData.inbound?.pending || 0)
        },
        outboundShipments: {
          outscan: todayData.outbound?.outscan || 0,
          pending: todayData.outbound?.pending || 0,
          total: (todayData.outbound?.outscan || 0) + (todayData.outbound?.pending || 0)
        },
        summary: {
          totalInbound: (todayData.inbound?.incoming || 0) + (todayData.inbound?.inscan || 0) + (todayData.inbound?.pending || 0),
          totalOutbound: (todayData.outbound?.outscan || 0) + (todayData.outbound?.pending || 0),
          totalPending: (todayData.inbound?.pending || 0) + (todayData.outbound?.pending || 0)
        }
      } : null,
      dataFreshness: {
        lastRefresh: new Date().toISOString(),
        selectedPeriod: day,
        isLoading: loading
      }
    }
  });

  useEffect(() => {
    //initialize();
    dispatch(getRegexPatternAction());
  }, []);
  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual
  );

  const { fetching, result } = getpremiseResponse;

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode)
      );
    }
  }, [getpremiseResponse]);

  const getRegexPatternResponse = useSelector(
    (state) => state?.dashboardReducer?.getRegexPatternReducer,
    shallowEqual
  );

  useEffect(() => {
    if (getRegexPatternResponse) {
      const { fetching, result } = getRegexPatternResponse;
      if (!fetching && result) {
        const pattern = result?.data?.configValue?.pattern;
        if (pattern) {
          localStorage.setItem("regexPattern", pattern);
          //console.log("Stored in localStorage:", localStorage.getItem("regexPattern"));
        } else {
          console.error("No pattern found in response");
        }
      }
    }
  }, [getRegexPatternResponse]);

  const getAnnouncementsResponse = useSelector(
    (state) => state?.dashboardReducer?.getAnnouncementsReducer,
    shallowEqual
  );

  useEffect(() => {
    if (getAnnouncementsResponse) {
      const { fetching, result, error } = getAnnouncementsResponse;
      if (!fetching && result) {
        console.log("Announcements Data:", result.data);
        setDataSource(result.data);
      } else if (!fetching && error) {
        message.config({ top: 80 });
        showErrorMessage(error?.response?.data?.message);
      }
    }
  }, [getAnnouncementsResponse]);

  function getDate(day = "today") {
    const date = new Date();
    setDay(`${moment().format("hh:mm a")}  ${day}`);
    if (day === "yesterday") {
      setDay(day);
      // setOnClickTime(day);
      date.setDate(date.getDate() - 1);
    }

    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  }

  useEffect(() => {
    navigate("/dashboard", { state: { test: "test" } });

    if (showDashboardSection) {
      getTodaysData("today");
    }
    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
    getAnnouncements();
  }, []);

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  const getTodaysData = async (day) => {
    let dates = getDate(day);
    getScannedAndUnscanned();
  };

  const dashboardIncomingBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardIncomingBagsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanBagsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanToCpShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanToCpShipmentsClickableReducer,
    shallowEqual
  );

  const dashboardInscanShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardInscanShipmentsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanShipmentsClickableReducer,
    shallowEqual
  );

  const dashboardIncomingShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardIncomingShipmentsClickableReducer,
    shallowEqual
  );
  const dashboardInscanBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardInscanBagsClickableReducer,
    shallowEqual
  );

  // Removed dashboard overview Redux side-effects since we fetch directly.

  useEffect(() => {
    if (dashboardIncomingBagsClickableResponse) {
      const { fetching, result, error } = dashboardIncomingBagsClickableResponse;
      setIsIncomingBagsLoading(fetching);
      if (result && !fetching) {
        setIncomingBagsData(result.data || []);
        if (result.pagination) {
          setIncomingBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardIncomingBagsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanBagsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanBagsClickableResponse;
      setIsOutscanBagsLoading(fetching);
      if (result && !fetching) {
        setOutscanBagsData(result.data || []);
        if (result.pagination) {
          setOutscanBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanBagsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanToCpShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanToCpShipmentsClickableResponse;
      setIsOutscanToCPShipmentsLoading(fetching);
      if (result && !fetching) {
        setOutscanToCPShipmentsData(result.data || []);
        if (result.pagination) {
          setOutscanToCPShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanToCpShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardInscanShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardInscanShipmentsClickableResponse;
      setIsInscanShipmentsLoading(fetching);
      if (result && !fetching) {
        setInscanShipmentsData(result.data || []);
        if (result.pagination) {
          setInscanShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardInscanShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanShipmentsClickableResponse;
      setIsOutscanShipmentsLoading(fetching);
      if (result && !fetching) {
        setOutscanShipmentsData(result.data || []);
        if (result.pagination) {
          setOutscanShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardIncomingShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardIncomingShipmentsClickableResponse;
      setIsIncomingShipmentsLoading(fetching);
      if (result && !fetching) {
        setIncomingShipmentsData(result.data || []);
        if (result.pagination) {
          setIncomingShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardIncomingShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardInscanBagsClickableResponse) {
      const { fetching, result, error } = dashboardInscanBagsClickableResponse;
      setIsInscanBagsLoading(fetching);
      if (result && !fetching) {
        setInscanBagsData(result.data || []);
        if (result.pagination) {
          setInscanBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardInscanBagsClickableResponse]);

  const getScannedAndUnscanned = async () => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }

    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;

    const token = getToken();
    const headers = {
      Authorization: token,
      token: token?.split("Bearer ")[1],
      "SMCS-PREMISE-ID": defaultPremiseId,
    };

    setLoading(true);
    try {
      const [
        liveOverviewRes, liveIncomingRes, pastOverviewRes, pastIncomingRes,
        liveBagOverviewRes, liveBagIncomingRes, pastBagOverviewRes, pastBagIncomingRes
      ] = await Promise.all([
        axios.get(`${urls.DASHBOARD_OVERVIEW_SHIPMENT}?premiseId=${effectivePremiseId}`, { headers }),
        axios.get(`${urls.DASHBOARD_INCOMING_OVERVIEW_SHIPMENT}?topremiseid=${effectivePremiseId}`, { headers }),
        axios.get(`${urls.DASHBOARD_OVERVIEW_SHIPMENT}?premiseId=${effectivePremiseId}&tab=PAST`, { headers }),
        axios.get(`${urls.DASHBOARD_INCOMING_OVERVIEW_SHIPMENT}?topremiseid=${effectivePremiseId}&tab=PAST`, { headers }),
        axios.get(`${urls.DASHBOARD_OVERVIEW_BAG}?premiseId=${effectivePremiseId}`, { headers }),
        axios.get(`${urls.DASHBOARD_INCOMING_OVERVIEW_BAG}?topremiseid=${effectivePremiseId}`, { headers }),
        axios.get(`${urls.DASHBOARD_OVERVIEW_BAG}?premiseId=${effectivePremiseId}&tab=PAST`, { headers }),
        axios.get(`${urls.DASHBOARD_INCOMING_OVERVIEW_BAG}?topremiseid=${effectivePremiseId}&tab=PAST`, { headers })
      ]);

      const liveOverview = liveOverviewRes.data?.data?.[0] || {};
      const liveIncoming = liveIncomingRes.data?.data?.[0] || {};
      const pastOverview = pastOverviewRes.data?.data?.[0] || {};
      const pastIncoming = pastIncomingRes.data?.data?.[0] || {};

      const liveBagOverview = liveBagOverviewRes.data?.data?.[0] || {};
      const liveBagIncoming = liveBagIncomingRes.data?.data?.[0] || {};
      const pastBagOverview = pastBagOverviewRes.data?.data?.[0] || {};
      const pastBagIncoming = pastBagIncomingRes.data?.data?.[0] || {};

      setTodayData({
        hub: {
          shipment_wise: {
            incoming: liveIncoming.incoming_shipment || 0,
            inscan: liveOverview.inscan_shipment || 0,
            outscan: liveOverview.outscan_shipment || 0,
            pending: liveOverview.outscan_to_cp_shipments || 0
          },
          bag_wise: {
            incoming: liveBagIncoming.incoming_bag || liveBagIncoming.incoming_bags || liveBagIncoming.incoming || 0,
            inscan: liveBagOverview.inscan_bag || liveBagOverview.inscan_bags || liveBagOverview.inscan || 0,
            outscan: liveBagOverview.outscan_bag || liveBagOverview.outscan_bags || liveBagOverview.outscan || 0,
            pending: liveBagOverview.outscan_to_cp_bags || liveBagOverview.outscan_to_cp_bag || liveBagOverview.pending || 0
          }
        },
        cp: {
          shipment_wise: {
            incoming: pastIncoming.incoming_shipment || 0,
            inscan: pastOverview.inscan_shipment || 0,
            outscan: pastOverview.outscan_shipment || 0,
            pending: pastOverview.outscan_to_cp_shipments || 0
          },
          bag_wise: {
            incoming: pastBagIncoming.incoming_bag || pastBagIncoming.incoming_bags || pastBagIncoming.incoming || 0,
            inscan: pastBagOverview.inscan_bag || pastBagOverview.inscan_bags || pastBagOverview.inscan || 0,
            outscan: pastBagOverview.outscan_bag || pastBagOverview.outscan_bags || pastBagOverview.outscan || 0,
            pending: pastBagOverview.outscan_to_cp_bags || pastBagOverview.outscan_to_cp_bag || pastBagOverview.pending || 0
          }
        }
      });
    } catch (error) {
      console.error("Error fetching dashboard data", error);
    } finally {
      setLoading(false);
    }
  };



  const handleCardClick = (title, count, tabValue, type = "shipment") => {
    if (count === 0) return;
    setCardDetailsModal({ visible: true, title, count, type });
    setModalTab(tabValue);
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;

    if (type === "shipment") {
      if (title === CARD_TITLES.INCOMING_SHIPMENT || title === CARD_TITLES.INCOMING_SHIPMENTS || title === "Incoming") {
        setIncomingShipmentsData([]);
        setIncomingShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardIncomingShipmentsClickable({ incominghubid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      } else if (title === CARD_TITLES.AVAILABLE_SHIPMENT || title === CARD_TITLES.AVAILABLE_SHIPMENTS || title === "Available") {
        setInscanShipmentsData([]);
        setInscanShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardInscanShipmentsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      } else if (title === CARD_TITLES.OUTSCAN_SHIPMENT || title === CARD_TITLES.OUTSCAN_SHIPMENTS || title === "Outscan") {
        setOutscanShipmentsData([]);
        setOutscanShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardOutscanShipmentsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      } else if (title === CARD_TITLES.OUTSCAN_TO_CP_SHIPMENT || title === CARD_TITLES.OUTSCAN_TO_CP_SHIPMENTS || title === "Outscan To CP") {
        setOutscanToCPShipmentsData([]);
        setOutscanToCPShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardOutscanToCpShipmentsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      }
    } else if (type === "bag") {
      if (title === CARD_TITLES.INCOMING_BAG || title === CARD_TITLES.INCOMING_BAGS || title === "Incoming") {
        setIncomingBagsData([]);
        setIncomingBagsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardIncomingBagsClickable({ topremiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      } else if (title === CARD_TITLES.AVAILABLE_BAG || title === CARD_TITLES.AVAILABLE_BAGS || title === "Available") {
        setInscanBagsData([]);
        setInscanBagsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardInscanBagsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      } else if (title === CARD_TITLES.OUTSCAN_BAG || title === CARD_TITLES.OUTSCAN_BAGS || title === "Outscan") {
        setOutscanBagsData([]);
        setOutscanBagsPagination({ current: 1, pageSize: 10, total: 0 });
        dispatch(getDashboardOutscanBagsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
      }
    }
  };

  const handleIncomingBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardIncomingBagsClickable({
      topremiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardOutscanBagsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanToCpShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardOutscanToCpShipmentsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleInscanShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardInscanShipmentsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardOutscanShipmentsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleIncomingShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardIncomingShipmentsClickable({
      incominghubid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleInscanBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = modalTab;
    dispatch(getDashboardInscanBagsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const getAnnouncements = () => {
    dispatch(getAnnouncementsAction());
  };

  const isVideo = (url) => {
    if (!url) return false;
    return url.match(/\.(mp4|webm|ogg|mov|avi)(\?|#|$)/i);
  };

  const isImage = (url) => {
    if (!url) return false;
    return url.match(/\.(jpeg|jpg|gif|png|webp)(\?|#|$)/i);
  };

  const isPdf = (url) => {
    if (!url) return false;
    return url.match(/\.pdf(\?|#|$)/i);
  };

  const getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    const name = parts[parts.length - 1].split("?")[0];
    return decodeURIComponent(name);
  };

  const cleanHtml = (html) => {
    if (!html) return "";
    return html.replace(/(<br\s*\/?>|&nbsp;|\s)+$/gi, "").replace(/<p>(&nbsp;|\s)*<\/p>$/gi, "");
  };

  const getAttachmentUrl = (record) => {
    let url = record?.filePath ||
      record?.file ||
      record?.fileUrl ||
      record?.file_path ||
      record?.attachmentUrl ||
      record?.attachment ||
      record?.mediaPath ||
      record?.media_path;

    if (!url && record?.message) {
      const srcMatch = record.message.match(/src=['"]([^'"]+)['"]/i);
      const hrefMatch = record.message.match(/href=['"]([^'"]+)['"]/i);
      url = srcMatch ? srcMatch[1] : (hrefMatch ? hrefMatch[1] : null);
    }
    return url;
  };

  const showAnnouncement = (item) => {
    setSelectedAnnouncement(item);
    setIsAnnouncementModalVisible(true);
  };

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <RightOutlined />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <LeftOutlined />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };


  const visibleMenuItems = dashboardMenuList.filter(
    (item) =>
      !item.hideOnDashboard &&
      (item?.role === "" || item.role.some((e) => accountDetails?.roles?.includes(e)))
  );

  return (
    <div
      className={`dashboard-container${showDashboardSection ? "" : " dashboard-container--without-dashboard"
        }${rightPanelView === "announcements"
          ? " dashboard-container--announcements-view"
          : ""
        }`}
    >
      <Spin spinning={fetching}>
        <Form
          form={form}
          layout="vertical"
          // onFinish={onFinish}
          autoComplete="off"
        >
          <div className="dashboard-top-strip">
            {showDashboardSection && (
              <div className="dashboard-top-card dashboard-top-card-left">
                <div className="dashboard-top-title">
                  <img
                    src={dashboardTopIcon}
                    alt="dashboard icon"
                    className="dashboard-top-title-icon"
                  />
                  Dashboard
                </div>
              </div>
            )}
            {!showDashboardSection && (
              <div className="dashboard-top-card dashboard-top-card-quick-top">
                <div className="dashboard-top-title">
                  <img
                    src={quickActionTopIcon}
                    alt="quick action icon"
                    className="dashboard-top-title-icon"
                  />
                  Quick Action
                </div>
              </div>
            )}
            <div className="dashboard-top-card dashboard-top-card-live">
              <div
                className={`dashboard-top-title dashboard-top-title-right dashboard-top-title-toggle${rightPanelView === "live" ? " is-active" : ""
                  }`}
                onClick={() => setRightPanelView("live")}
                role="button"
                tabIndex={0}
              >
                <img
                  src={liveTicketTopIcon}
                  alt="live tickets icon"
                  className="dashboard-top-title-icon"
                />
                Live Tickets
              </div>
            </div>
          </div>

          <Row
            gutter={[12, 24]}
            className={`dashboard-container-row${showDashboardSection
              ? " dashboard-container-row--stats-sync"
              : " dashboard-container-row--quick-action-sync"
              }`}
          >
            <Col
              className="dashboard-container-col"
              xl={12}
              lg={12}
              md={24}
              sm={24}
              xs={24}
            >
              {!showDashboardSection && (
                <div className="dashboard-quick-action-inline">
                  <div
                    ref={quickActionPanelRef}
                    className="dashboard-quick-action-panel dashboard-quick-action-panel-inline"
                  >
                    <Row gutter={[8, 0]} className="dashboard-quick-action-inline-row">
                      {visibleMenuItems.map((item, index) => (
                        <Col
                          className="cash-booking quick-action-card"
                          key={index}
                        >
                          <DashbordCard
                            accountBookingArrowIcon={accountBookingArrowIcon}
                            accountBookingIcon={item.icon}
                            watchIcon={calenderIcon}
                            bookingType={item.title}
                            route={item.route}
                            id={item.id}
                            newReportUrl={item.newReportUrl}
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              )}
              {showDashboardSection && (
                <Spin spinning={todayData === null}>
                  <Row>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      ref={statsContentRef}
                      className="dashboard-container-col-innercol dashboard-container-col-innercol--plain dashboard-stats-content"
                    >
                      <Spin spinning={loading}>
                        <div className="custom-carousel">
                          <StatusRow
                            title={CARD_TITLES.LIVE_SHIPMENTS}
                            type="shipment"
                            status={{
                              incoming: todayData?.hub?.shipment_wise?.incoming,
                              inscan: todayData?.hub?.shipment_wise?.inscan,
                              outscan: todayData?.hub?.shipment_wise?.outscan,
                              pending: todayData?.hub?.shipment_wise?.pending,
                            }}
                            onCardClick={(title, count, cardType) => handleCardClick(title, count, undefined, cardType || "shipment")}
                          />
                          <StatusRow
                            title={CARD_TITLES.OVERDUE_SHIPMENTS}
                            type="shipment"
                            status={{
                              incoming: todayData?.cp?.shipment_wise?.incoming,
                              inscan: todayData?.cp?.shipment_wise?.inscan,
                              outscan: todayData?.cp?.shipment_wise?.outscan,
                              pending: todayData?.cp?.shipment_wise?.pending,
                            }}
                            onCardClick={(title, count, cardType) => handleCardClick(title, count, "PAST", cardType || "shipment")}
                          />
                          <StatusRow
                            title={CARD_TITLES.LIVE_BAGS}
                            type="bag"
                            status={{
                              incoming: todayData?.hub?.bag_wise?.incoming,
                              inscan: todayData?.hub?.bag_wise?.inscan,
                              outscan: todayData?.hub?.bag_wise?.outscan,
                              pending: todayData?.hub?.bag_wise?.pending,
                            }}
                            onCardClick={(title, count, cardType) => handleCardClick(title, count, undefined, cardType || "bag")}
                          />
                          <StatusRow
                            title={CARD_TITLES.OVERDUE_BAGS}
                            type="bag"
                            status={{
                              incoming: todayData?.cp?.bag_wise?.incoming,
                              inscan: todayData?.cp?.bag_wise?.inscan,
                              outscan: todayData?.cp?.bag_wise?.outscan,
                              pending: todayData?.cp?.bag_wise?.pending,
                            }}
                            onCardClick={(title, count, cardType) => handleCardClick(title, count, "PAST", cardType || "bag")}
                          />
                        </div>
                      </Spin>
                    </Col>
                  </Row>
                </Spin>
              )}
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24} className="dashboard-right-col">
              <div
                ref={liveTicketPanelRef}
                className="dashboard-live-ticket-panel dashboard-live-ticket-panel-tall"
              >
                {rightPanelView === "live" && (
                  <>
                    <LiveTickets
                      config={{
                        env: process.env.REACT_APP_ENV || "dev",
                        limit: 3,
                      }}
                      onTicketClick={setSelectedTicket}
                    />

                    <TicketDetail
                      ticket={selectedTicket}
                      onClose={() => setSelectedTicket(null)}
                    />
                  </>
                )}
                {rightPanelView === "announcements" && (
                  <div className="dashboard-right-announcement-panel">
                    {dataSource.length > 0 ? (
                      <List
                        itemLayout="horizontal"
                        dataSource={dataSource}
                        pagination={
                          dataSource.length > 3
                            ? {
                              pageSize: 3,
                            }
                            : false
                        }
                        renderItem={(item) => (
                          <List.Item
                            style={{ cursor: "pointer" }}
                            onClick={() => showAnnouncement(item)}
                          >
                            <List.Item.Meta
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      overflow: "hidden",
                                      flex: 1,
                                    }}
                                  >
                                    <img
                                      width="24px"
                                      height="24px"
                                      className="dashboard-container-card-div-messageIcon"
                                      src={dashbordMessageIcon}
                                      style={{ minWidth: "24px" }}
                                    />
                                    <span
                                      className="listTitle"
                                      style={{
                                        textTransform: "capitalize",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        marginLeft: "8px",
                                        color:
                                          item.priorityType === "HIGH"
                                            ? "#C40000"
                                            : item.priorityType === "MEDIUM"
                                              ? "#DF8100"
                                              : "#179503",
                                      }}
                                      title={item.title}
                                    >
                                      {item.title}
                                    </span>
                                  </div>
                                  {getAttachmentUrl(item) && (
                                    <Tooltip title="View Attachment">
                                      <img
                                        width="24px"
                                        height="24px"
                                        style={{
                                          marginLeft: "8px",
                                          verticalAlign: "middle",
                                          cursor: "pointer",
                                        }}
                                        src={attachmentIcon}
                                        alt="attachment"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              }
                              description={
                                <span className="listDiscription">
                                  {item.validFrom + " - " + item.validTo}
                                </span>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    ) : (
                      <div className="dashboard-right-announcement-empty">
                        No announcements available
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {showDashboardSection && (
            <div className="dashboard-bottom-strip">
              <div className="dashboard-top-card dashboard-top-card-quick-bottom">
                <div className="dashboard-top-title">
                  <img
                    src={quickActionTopIcon}
                    alt="quick action icon"
                    className="dashboard-top-title-icon"
                  />
                  Quick Action
                </div>
              </div>
              <div className="dashboard-quick-action-panel dashboard-quick-action-panel-bottom">
                <Row gutter={[8, 0]} className="dashboard-quick-action-row">
                  {visibleMenuItems.map((item, index) => (
                    <Col
                      className="cash-booking quick-action-card"
                      key={index}
                    >
                      <DashbordCard
                        accountBookingArrowIcon={accountBookingArrowIcon}
                        accountBookingIcon={item.icon}
                        watchIcon={calenderIcon}
                        bookingType={item.title}
                        route={item.route}
                        id={item.id}
                        newReportUrl={item.newReportUrl}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          )}

        </Form>
      </Spin>
      <Modal
        title={selectedAnnouncement?.title}
        visible={isAnnouncementModalVisible}
        onCancel={() => setIsAnnouncementModalVisible(false)}
        footer={false}
        width={650}
        className="square-modal"
      >
        <div className="modal-content-wrapper">
          <div
            className="message-content"
            style={{ fontSize: "14px", lineHeight: "1.6" }}
            dangerouslySetInnerHTML={{ __html: cleanHtml(selectedAnnouncement?.message) }}
          ></div>
          {getAttachmentUrl(selectedAnnouncement) && (
            <div className="media-preview" style={{ textAlign: "center", background: "#f5f5f5", padding: "0 10px 10px 10px", borderRadius: "8px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              {isVideo(getAttachmentUrl(selectedAnnouncement)) ? (
                <video
                  key={getAttachmentUrl(selectedAnnouncement)}
                  width="100%"
                  controls
                  autoPlay
                  muted
                  playsInline
                  src={getAttachmentUrl(selectedAnnouncement)}
                  style={{ borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                >
                  Your browser does not support the video tag.
                </video>
              ) : isImage(getAttachmentUrl(selectedAnnouncement)) ? (
                <img
                  src={getAttachmentUrl(selectedAnnouncement)}
                  alt="Attachment"
                  style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                />
              ) : isPdf(getAttachmentUrl(selectedAnnouncement)) ? (
                <iframe
                  src={getAttachmentUrl(selectedAnnouncement)}
                  width="100%"
                  height="400px"
                  style={{ border: "none", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                  title="PDF Preview"
                >
                  Your browser does not support iframes.
                  <a href={getAttachmentUrl(selectedAnnouncement)} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </iframe>
              ) : (
                <div className="file-attachment">
                  <a href={getAttachmentUrl(selectedAnnouncement)} target="_blank" rel="noopener noreferrer">
                    View Attachment
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
      <Modal
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: "50px" }}>
            <span>{cardDetailsModal?.title}</span>
            {VALID_MODAL_TITLES.includes(cardDetailsModal?.title) && (
              <span style={{ fontSize: "14px", fontWeight: "600", color: "#061624" }}>Total Count: {cardDetailsModal?.count}</span>
            )}
          </div>
        }
        visible={cardDetailsModal?.visible}
        onCancel={() => setCardDetailsModal(prev => ({ ...prev, visible: false }))}
        footer={false}
        width={
          VALID_MODAL_TITLES.includes(cardDetailsModal?.title)
            ? 1400
            : 400
        }
      >
        {cardDetailsModal?.type === "shipment" ? (
          (cardDetailsModal?.title === CARD_TITLES.INCOMING_SHIPMENT || cardDetailsModal?.title === CARD_TITLES.INCOMING_SHIPMENTS || cardDetailsModal?.title === "Incoming") ? (
            <Table
              dataSource={incomingShipmentsData}
              columns={incomingShipmentsColumns}
              pagination={incomingShipmentsPagination}
              loading={isIncomingShipmentsLoading}
              onChange={handleIncomingShipmentsTableChange}
              rowKey={(record, index) => record.awb_number || record._sno || index}
              scroll={{ x: 2400, y: 570 }}
            />
          ) : (cardDetailsModal?.title === CARD_TITLES.AVAILABLE_SHIPMENT || cardDetailsModal?.title === CARD_TITLES.AVAILABLE_SHIPMENTS || cardDetailsModal?.title === "Available") ? (
            <Table
              dataSource={inscanShipmentsData}
              columns={inscanShipmentsColumns}
              pagination={inscanShipmentsPagination}
              loading={isInscanShipmentsLoading}
              onChange={handleInscanShipmentsTableChange}
              rowKey={(record, index) => record.awb_number || record._sno || index}
              scroll={{ x: true }}
            />
          ) : (cardDetailsModal?.title === CARD_TITLES.OUTSCAN_SHIPMENT || cardDetailsModal?.title === CARD_TITLES.OUTSCAN_SHIPMENTS || cardDetailsModal?.title === "Outscan") ? (
            <Table
              dataSource={outscanShipmentsData}
              columns={outscanShipmentsColumns}
              pagination={outscanShipmentsPagination}
              loading={isOutscanShipmentsLoading}
              onChange={handleOutscanShipmentsTableChange}
              rowKey={(record, index) => record.awb_number || record._sno || index}
              scroll={{ x: 1800, y: 570 }}
            />
          ) : (cardDetailsModal?.title === CARD_TITLES.OUTSCAN_TO_CP_SHIPMENTS || cardDetailsModal?.title === CARD_TITLES.OUTSCAN_TO_CP_SHIPMENT || cardDetailsModal?.title === "Outscan To CP") ? (
            <Table
              dataSource={outscanToCPShipmentsData}
              columns={outscanToCPShipmentsColumns}
              pagination={outscanToCPShipmentsPagination}
              loading={isOutscanToCPShipmentsLoading}
              onChange={handleOutscanToCpShipmentsTableChange}
              rowKey={(record, index) => record.awb_number || record._sno || index}
              scroll={{ x: true }}
            />
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h2>{cardDetailsModal?.count}</h2>
              <p>{cardDetailsModal?.title}</p>
            </div>
          )
        ) : cardDetailsModal?.type === "bag" ? (
          (cardDetailsModal?.title === CARD_TITLES.INCOMING_BAG || cardDetailsModal?.title === CARD_TITLES.INCOMING_BAGS || cardDetailsModal?.title === "Incoming") ? (
            <Table
              dataSource={incomingBagsData}
              columns={incomingBagsColumns}
              pagination={incomingBagsPagination}
              loading={isIncomingBagsLoading}
              onChange={handleIncomingBagsTableChange}
              rowKey={(record, index) => record.bag_number || record._sno || index}
              scroll={{ x: true }}
            />
          ) : (cardDetailsModal?.title === CARD_TITLES.AVAILABLE_BAG || cardDetailsModal?.title === CARD_TITLES.AVAILABLE_BAGS || cardDetailsModal?.title === "Available") ? (
            <Table
              dataSource={inscanBagsData}
              columns={inscanBagsColumns}
              pagination={inscanBagsPagination}
              loading={isInscanBagsLoading}
              onChange={handleInscanBagsTableChange}
              rowKey={(record, index) => record.bag_number || record._sno || index}
              scroll={{ x: 2000, y: 570 }}
            />
          ) : (cardDetailsModal?.title === CARD_TITLES.OUTSCAN_BAG || cardDetailsModal?.title === CARD_TITLES.OUTSCAN_BAGS || cardDetailsModal?.title === "Outscan") ? (
            <Table
              dataSource={outscanBagsData}
              columns={outscanBagsColumns}
              pagination={outscanBagsPagination}
              loading={isOutscanBagsLoading}
              onChange={handleOutscanBagsTableChange}
              rowKey={(record, index) => record.bag_number || record._sno || index}
              scroll={{ x: true }}
            />
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h2>{cardDetailsModal?.count}</h2>
              <p>{cardDetailsModal?.title}</p>
            </div>
          )
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <h2>{cardDetailsModal?.count}</h2>
            <p>{cardDetailsModal?.title}</p>
          </div>
        )}
      </Modal>
    </div>
  );
}
Dashboard.propTypes = {
  data1: PropTypes.number,
};

export default Dashboard;




const StatusRow = ({ title, status, type, onCardClick, style }) => {
  const isShipment = type === "shipment";

  const incomingLabel = isShipment ? (status.incoming === 1 ? CARD_TITLES.INCOMING_SHIPMENT : CARD_TITLES.INCOMING_SHIPMENTS) : (status.incoming === 1 ? CARD_TITLES.INCOMING_BAG : CARD_TITLES.INCOMING_BAGS);
  const inscanLabel = isShipment ? (status.inscan === 1 ? CARD_TITLES.AVAILABLE_SHIPMENT : CARD_TITLES.AVAILABLE_SHIPMENTS) : (status.inscan === 1 ? CARD_TITLES.AVAILABLE_BAG : CARD_TITLES.AVAILABLE_BAGS);
  const outscanLabel = isShipment ? (status.outscan === 1 ? CARD_TITLES.OUTSCAN_SHIPMENT : CARD_TITLES.OUTSCAN_SHIPMENTS) : (status.outscan === 1 ? CARD_TITLES.OUTSCAN_BAG : CARD_TITLES.OUTSCAN_BAGS);
  const pendingLabel = isShipment ? (status.pending === 1 ? CARD_TITLES.OUTSCAN_TO_CP_SHIPMENT : CARD_TITLES.OUTSCAN_TO_CP_SHIPMENTS) : (status.pending === 1 ? CARD_TITLES.OUTSCAN_TO_CP_BAG : CARD_TITLES.OUTSCAN_TO_CP_BAGS);

  const bgStyle = {
    backgroundColor: isShipment ? "#F4F7FB" : "#FFF7EB"
  };

  const getCardStyle = (baseStyle) => ({
    ...baseStyle,
    ...bgStyle,
  });

  return (
    <div className="status-section-card dashboard-white-card" style={style}>
      <div className="status-section-title-card" style={bgStyle}>
        <div className="status-section-title">
          <img
            src={isShipment ? shipmentHeaderIcon : bagHeaderIcon}
            alt={`${title} icon`}
            className="status-section-title-icon"
          />
          {title}
        </div>
      </div>
      <div className={`autoAdjust ${!isShipment ? "autoAdjust-3-cols" : ""}`}>
        <div>
          <StatusCard
            count={status.incoming}
            label={incomingLabel}
            style={getCardStyle(cardStyles.incoming)}
            onClick={() => onCardClick && onCardClick(incomingLabel, status.incoming || 0, type)}
          />
        </div>
        <div>
          <StatusCard
            count={status.inscan}
            label={inscanLabel}
            style={getCardStyle(cardStyles.inscan)}
            onClick={() => onCardClick && onCardClick(inscanLabel, status.inscan || 0, type)}
          />
        </div>
        <div>
          <StatusCard
            count={status.outscan}
            label={outscanLabel}
            style={getCardStyle(cardStyles.outscan)}
            onClick={() => onCardClick && onCardClick(outscanLabel, status.outscan || 0, type)}
          />
        </div>
        {isShipment && (
          <div>
            <StatusCard
              count={status.pending}
              label={pendingLabel}
              style={getCardStyle(cardStyles.pending)}
              onClick={() => onCardClick && onCardClick(pendingLabel, status.pending || 0, type)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const StatusCard = ({ count, label, style, onClick }) => (
  <Card bordered className="dashboard-status-card" style={{ ...style, cursor: onClick ? "pointer" : "default" }} onClick={onClick}>
    <div className="dashboard-status-count" style={{ color: style?.textColor || "#111827" }}>{count ? count : 0}</div>
    <div className="dashboard-status-label">{label}</div>
  </Card>
);
